export default "__VITE_ASSET__DsNz3gqt__"